module.exports = __webpack_public_path__ + "spa_static_mobile/img/qrcode.38068b81.png";